import { FaEdit, FaShip } from "react-icons/fa";
import { MdBedroomParent } from "react-icons/md";
import { StructureBuilder } from "sanity/structure";

export default (S: StructureBuilder) =>
  S.listItem()
    .title("Ship")
    .icon(FaShip)
    .child(
      S.list()
        .title("Ship")
        .items([
          S.listItem()
            .title("Ships")
            .schemaType("ship")
            .child(
              S.documentTypeList("ship").child((shipId) => {
                const normalizedId = shipId.replace("drafts.", "");

                return S.list()
                  .title("Ship")
                  .items([
                    S.listItem()
                      .title("Edit Ship")
                      .id("edit")
                      .icon(FaEdit)
                      .child(
                        S.document().schemaType("ship").documentId(shipId)
                      ),
                    S.divider(),
                    S.listItem()
                      .title("Ship Versions")
                      .icon(FaShip)
                      .id("versions")
                      .child(
                        S.documentList()
                          .title("Ship Versions")
                          .schemaType("shipVersionV2")
                          .filter(
                            '_type == "shipVersionV2" && ship._ref in [$id, $draftId]'
                          )
                          .params({
                            id: normalizedId,
                            draftId: `drafts.${normalizedId}`
                          })
                          .initialValueTemplates([
                            S.initialValueTemplateItem(
                              "shipVersionV2-for-ship",
                              { shipId: normalizedId }
                            )
                          ])
                      )
                  ]);
              })
            ),
          S.listItem()
            .title("Suites")
            .schemaType("suiteCategory")
            .child(S.documentTypeList("suiteCategory")),
          S.listItem()
            .title("Suite Classes")
            .schemaType("suiteClassGroup")
            .child(
              S.documentTypeList("suiteClassGroup")
                .title("Suite Classes")
                .child((groupId) => {
                  const normalizedId = groupId.replace("drafts.", "");

                  return S.list()
                    .title("Suite Class Group")
                    .items([
                      S.listItem()
                        .title("Edit Suite Class Group")
                        .id("edit")
                        .icon(FaEdit)
                        .child(
                          S.document()
                            .schemaType("suiteClassGroup")
                            .documentId(groupId)
                        ),
                      S.divider(),
                      S.listItem()
                        .title("Suite Classes")
                        .icon(MdBedroomParent)
                        .id("versions")
                        .child(
                          S.documentTypeList("suiteClass")
                            .title("Suite Classes")
                            .filter(
                              '_type == "suiteClass" && suiteClassGroup._ref in [$id, $draftId]'
                            )
                            .params({
                              id: normalizedId,
                              draftId: `drafts.${normalizedId}`
                            })
                            .defaultOrdering([
                              { field: "validFrom", direction: "asc" }
                            ])
                            .initialValueTemplates([
                              S.initialValueTemplateItem(
                                "suiteClass-for-group",
                                {
                                  suiteClassGroupId: normalizedId
                                }
                              )
                            ])
                        )
                    ]);
                })
            ),
          S.listItem()
            .title("Special Perks Type")
            .schemaType("specialPerksType")
            .child(S.documentTypeList("specialPerksType")),
          S.listItem()
            .title("Suite Class Inclusion Categories")
            .schemaType("suiteClassInclusionCategory")
            .child(S.documentTypeList("suiteClassInclusionCategory")),
          S.listItem()
            .title("Suite Class Generic Features")
            .schemaType("suiteClassGenericFeature")
            .child(S.documentTypeList("suiteClassGenericFeature")),
          S.listItem()
            .title("Public Areas")
            .schemaType("publicAreaCategory")
            .child(S.documentTypeList("publicAreaCategory")),
          S.listItem()
            .title("Dining Areas")
            .schemaType("diningAreaCategory")
            .child(S.documentTypeList("diningAreaCategory"))
        ])
    );
